import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Select, Button } from 'antd';
import { Grid } from '@material-ui/core';
import TextInput from 'app/components/TextInput';


import ProcessTableContainer from 'app/containers/ProcessTableContainer';
import { clearProcess, fetchProcess } from 'app/actions/ProcessActions';
const { Option } = Select;
const SelectItem = (name = [], value) => {
    let x = [...new Set(name.map(i => i[value]))];
    return typeof x !== 'undefined' && x !== null ? x.map((c, i) => <Option key={i}>{c}</Option>) : (x === null ? <Option key={'cargando'}>No existen valores..</Option> : <Option disabled key={'cargando'}>Cargando valores..</Option>);

}

export default function CompanyForm(props) {
    const classes =props.classes
    const dispatch = useDispatch();
    const [cp, setCP] = useState('');
    const [front, setFront] = useState('');
    
    const data = {
        idCommunicationProgram: cp,
        idFront :front,
        sortColumn: Object.keys(props.sorter).length > 0 ? props.sorter.field : '',
        sortDir: Object.keys(props.sorter).length > 0 ? props.sorter.order === "ascend" ? "ASC" : "DESC" : '',
        offset: (0 * props.pagination.pageSize),
        limit: props.pagination.pageSize
    }
    const fetchProcessAction = () => dispatch(fetchProcess(data, cp));

    const search = () => {
        dispatch(clearProcess());
        fetchProcessAction();
        props.setIsResult(true)
        props.setFormData(data);
    }
    const  handleChange = (i, key) => {

        if(key==='communicationProgramName')setCP(i.idCommunicationProgram)
        if(key==='frontName')setFront(i.idFront)
    }

    return (
        <div>
            <ProcessTableContainer isFilters={true}>
                {((params)=>{
                    return <div>
                        <Grid container direction='row'>
                        <Grid item md={6} lg={6} sm={6} xs={12}>
                            <TextInput
                                text='Programa de comunicación'
                                color='darker'
                                size='label'
                                showSearch
                                weight='medium'
                                placeholder='Selecciona programa de comunicación'
                                style={props.styles.inputSelect}
                                onChange={(v, i)=>handleChange(params.processFilters[0].communicationProgram[v], 'communicationProgramName')}
                            >
                                {params.processFilters.length>0 ? SelectItem(params.processFilters[0].communicationProgram, 'communicationProgramName'):''}
                            </TextInput>
                        </Grid>                        
                        <Grid item md={6} lg={6} sm={6} xs={12}>
                            <TextInput
                                text='Frente'
                                color='darker'
                                size='label'
                                showSearch
                                weight='medium'
                                placeholder='Selecciona frente'
                                style={props.styles.inputSelect}
                                onChange={(v, i)=>handleChange(params.processFilters[0].front[v], 'frontName')}
                            >
                                {params.processFilters.length>0 ? SelectItem(params.processFilters[0].front, 'frontName'):''}
                            </TextInput>
                        </Grid>                        
                    </Grid>              
                        <div className={classes.container} style={props.styles.baseVerticalMargin}>
                            <Button
                                className={classes.button}
                                variant="contained"
                                type="primary"
                                disabled={data.idCommunicationProgram===''|| data.idFront === ''}
                                onClick={() => search()}
                            >
                                Buscar
                                </Button>
                        </div>
                    </div>
                })}
        </ProcessTableContainer>
        </div>
    )
}